<template>
  <div class="mb-3">
    <b-card class="border !rounded-xl border-gray-200 mb-3">
      <div class="grid items-start grid-cols-1 lg:grid-cols-2 gap-3 ">
        <ProductSelect
          :form-data="formData"
          :is-edit-mode="isEditMode"
          @validate="validateForm"
          @update-selected-products="val => selectedProducts = val"
        />
        <WarehouseSelect
          :form-data="formData"
          @validate="validateForm"
          @update-address="val => $emit('update:address-id', val)"
        />
      </div>
    </b-card>

    <BulkEdit
      :selected-count="tableSelectedCount"
      :discount-type="bulkDiscountType"
      @submit="onBulkEdit"
      @update:discount-type="val => bulkDiscountType = val"
    />

    <ProductTable
      :products="selectedProducts"
      :bulk-payload="bulkPayload"
      :discount-type="bulkDiscountType"
      @change="onTableChange"
      @remove="onRemoveProduct"
      @remove-all="removeAllProducts"
      @update:selected-count="val => tableSelectedCount = val"
      @update:has-invalid-price="val => $emit('update:has-invalid-price', val)"
      @update:has-price-below-one="val => hasPriceBelowOne = val"
      @update:invalid-price-products="val => $emit('update:invalid-price-products', val)"
    />
  </div>
</template>

<script>
import ProductSelect from './product/ProductSelect.vue'
import WarehouseSelect from './product/WarehouseSelect.vue'
import BulkEdit from './product/BulkEdit.vue'
import ProductTable from './product/ProductTable.vue'

export default {
  components: {
    ProductSelect,
    WarehouseSelect,
    BulkEdit,
    ProductTable,
  },
  props: {
    formData: {
      type: Object,
      default: () => ({
        product_ids: [],
        address_id: null,
        product_discount: 0,
        payment_discount: 0,
      }),
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    hasInvalidPrice: {
      type: Boolean,
      default: false,
    },
    invalidPriceProducts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedProducts: [],
      bulkPayload: null,
      bulkDiscountType: 'percentage',
      tableSelectedCount: 0,
      hasPriceBelowOne: false,
      isDiscountTypeInitialized: false,
    }
  },
  watch: {
    formData: {
      handler() {
        this.validateForm()
      },
      deep: true,
      immediate: true,
    },
    bulkDiscountType(val) {
      this.$emit('update:discount-type', val)
    },
    'formData.products': {
      handler(newVal) {
        if (this.isEditMode && !this.isDiscountTypeInitialized && newVal && newVal.length > 0) {
          this.bulkDiscountType = newVal[0].discount_type || 'percentage'
          this.isDiscountTypeInitialized = true
        }
      },
      immediate: true,
    },
    hasInvalidPrice: {
      handler() {
        // we keep this just in case, but validateForm depends on hasPriceBelowOne now
        // so no need to validate on hasInvalidPrice change unless needed.
        this.validateForm()
      },
      immediate: true,
    },
    hasPriceBelowOne: {
      handler() {
        this.validateForm()
      },
    },
  },
  methods: {
    validateForm() {
      const isProductValid = Array.isArray(this.formData.product_ids) && this.formData.product_ids.length > 0
      const isAddressValid = this.formData.address_id !== undefined && this.formData.address_id !== null && String(this.formData.address_id).trim() !== ''
      const isPriceValid = !this.hasPriceBelowOne
      this.$emit('update:disable-next', !(isProductValid && isAddressValid && isPriceValid))
    },
    onBulkEdit(payload) {
      this.bulkPayload = payload
      this.$emit('bulk-edit', payload)
    },
    onTableChange(rows) {
      this.$emit('table-change', rows)
    },
    onRemoveProduct(id) {
      // Remove from formData.product_ids so ProductSelect stays in sync
      if (this.formData.product_ids) {
        const idx = this.formData.product_ids.indexOf(id)
        if (idx !== -1) this.formData.product_ids.splice(idx, 1)
      }
      this.selectedProducts = this.selectedProducts.filter(p => p.id !== id)
    },
    removeAllProducts() {
      this.selectedProducts = []
      this.formData.product_ids = []
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
